import { mixins } from 'vue-class-component';
import { Component, Inject, Prop, Ref, Watch } from 'vue-property-decorator';
import AlertService from '@/shared/alert/alert.service';
import ApeironComponent from '@/components/commons/apeiron-component.model';
import { Solucion } from '@/shared/model/solucion.model';
import { RolAutoridad } from '@/shared/model/enumerations/rol-autoridad.model';
import { maxLength, minLength, required, requiredIf } from 'vuelidate/lib/validators';
import { BModal, BTable } from 'bootstrap-vue';
import { TipoAccion } from '@/shared/model/enumerations/tipo-accion.model';
import SolicitudService from '@/entities/solicitud/solicitud.service';
import { CharCodes } from '@/shared/model/enumerations/caracteres.model';
import { ICatalogoDto } from '@/shared/model/catalogoDto.model';
import { IDependienteEconomico } from '@/shared/model/persona/dependiente-economico';
import { CURP } from '@/shared/formatter/regex-utils';
import { AMERICA_MEXICO, DATE_ONLY_DAY, DATE_ONLY_MONTH, DATE_ONLY_YEAR, ES_MX, LOCALE } from '@/shared/date/date-utils';
import { ICatalogoBV } from '@/shared/model/catalogoBV.model';
import { CatalogosApi } from '@conacyt/catalogos-client';
import { ICatalogoGenericoDto } from '@/shared/model/catalogoGenericoDto.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import { IInstitucionesMs } from '@/shared/model/seguimiento/instituciones-ms.model';
import { ICatalogoApoyoObtener } from '@/shared/model/catalogoApoyoObtener.model';
import { ICatalogoPaises } from '@/shared/model/catalogoPaises.model';
import { IMontoRubro } from '@/shared/model/montoRubro.model';

import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import { IRubro } from '@/shared/model/rubro.model';
import { EstadoSolicitud } from '@/shared/model/enumerations/estado-solicitud.model';
import { IConveniosColaboracion } from '@/shared/model/seguimiento/financiero/convenios-colaboracion.model';
import ConveniosColaboracionService from '@/entities/seguimiento/financiero/convenios-colaboracion.service';
import { TipoBecaExtranjero } from '@/shared/model/enumerations/tipo-beca-extranjero.model';

dayjs.extend(timezone);

const VALIDATIONS = function () {
  return {
    solicitud: {
      datos_conciliados: {
        apoyo: {
          tipoApoyo: {
            required,
          },
          pais: {
            required,
          },
          institucion: {
            required,
          },
          convenio: {
            required,
          },
          programa: {
            required,
          },
        },
        periodo: {
          duracionBeca: {
            required,
          },
          fechaFinBeca: {
            required,
          },
          fechaFinEstudios: {
            required,
          },
          fechaInicioBeca: {
            required,
          },
          fechaInicioEstudios: {
            required,
          },
        },
      },
    },
    dependientesNuevo: {
      esExtranjero: {
        required,
      },
      curp: {
        required: requiredIf(() => !this.curpReadOnly),
        minLength: minLength(1),
        maxLength: maxLength(18),
        CURP,
      },
      nombre: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(50),
      },
      primerApellido: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(50),
      },
      segundoApellido: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(50),
      },
      fechaNacimiento: {
        required,
      },
      sexo: {
        required,
      },
      parentesco: {
        required,
      },
    },
  };
};
@Component({
  validations: VALIDATIONS,
  computed: {
    userInfo: {
      get() {
        return this.$store.getters.userInfo;
      },
    },
  },
})
export default class ConciliacionCompletaComponent extends mixins(ApeironComponent) {
  @Inject('alertService') public alertService: () => AlertService;
  @Inject('solicitudService') private solicitudService: () => SolicitudService;
  @Inject('catalogosApi') private catalogosApi: () => CatalogosApi;
  @Inject('conveniosColaboracionService') public conveniosColaboracionService: () => ConveniosColaboracionService;

  @Prop({ required: true })
  public solicitud: Solicitud;

  @Prop({ required: true })
  public solucion: Solucion;

  @Ref('removeDependiente')
  public readonly removeDependiente: BModal;

  @Ref('changeDependiente')
  public readonly changeDependiente: BModal;

  @Ref('tableRubros')
  public tableRubros: BTable;

  public fields = [{ label: 'Rubros', key: 'rubros' }];
  public nacionalidadOptions: Array<ICatalogoDto> = [];
  public parentescoOption: Array<ICatalogoDto> = [];
  public sexoOptions: Array<ICatalogoDto> = [];
  public curpReadOnly = false;
  public sexoDisabled = true;
  public nacionalidadDisabled = false;
  public confirmo = false;
  public disabledConfirmo = false;
  public removeIndex = null;
  public dependientesNuevo: IDependienteEconomico = {
    curp: null,
    nombre: null,
    primerApellido: null,
    segundoApellido: null,
    fechaNacimiento: null,
    sexo: null,
    parentesco: null,
    esExtranjero: false,
  };

  public valueValidateInput: string;
  public valueFormatInput: string;

  public parts: Array<any>;
  public integerPart: string;
  public decimalPart: string;

  public readonly userInfo: any;
  public locale: string = LOCALE;

  public catApoyoObtener: Array<ICatalogoBV> = [];
  public catPais: Array<ICatalogoGenericoDto> = [];
  public catInstituciones: Array<ICatalogoDto> = [];
  public catConvenios: Array<IConveniosColaboracion> = [];
  public catPrograma: Array<any> = [];

  public anio = 0;

  //PAginado Catalogos
  private totalPagPaises = 0;
  private totalPagInstituciones = 0;

  public fechaPeriodo = null;
  public inicioMinimoBeca = '';
  public inicioMaximoBeca = '';
  public duracionMeses = '';
  public inicioMaximoBecaBandera = false;
  public fechaInicioMayorAFinBandera = false;
  public formatMesLong = '';
  public optionsLocalDateMx = { timeZone: AMERICA_MEXICO };
  public today = new Date();
  public showConvenios = false;

  public resetDependiente: any;
  public issste = false;
  public version;
  public isApoyos = false;
  public isGeneral = false;
  public guiaISSSTE =
    'https://secihti.mx/wp-content/uploads/becas/becas_extranjero/documentos_restringidos/2026/Guia_Asignacion_Formalizacion_BEXT_RMYET_2026.pdf';
  public guiaApoyos = ' https://enbc.secihti.mx/wp-content/uploads/2026/02/Guia_Postulacion_BEXT_ACMYP_2026-20260423T235749.pdf';
  public guiaGeneral =
    'https://secihti.mx/wp-content/uploads/becas/becas_extranjero/documentos_restringidos/2026/Guia_Asignacion_Formalizacion_BEXT_2026.pdf';
  public loadingInstituciones = false;

  public mounted() {
    this.initCatalogos();
    this.onDisabledConfirma();
    this.inicioMinimoBeca = this.solucion.params.inicioMinimoBeca;
    this.inicioMaximoBeca = this.solucion.params.inicioMaximoBeca;
    this.formatMesLong = this.inicioMaximoBeca;
    if (this.solucion.params.tipoBecaExtranjero != 'ESTANCIA_TECNICA_JAPON') this.fieldsRubros();
    this.issste = this.solucion.params.tipoBecaExtranjero === 'CONVENIO_ISSSTE';
    this.isApoyos = this.solucion.params.tipoBecaExtranjero === 'APOYOS_COMPLEMENTARIOS_EXT';
    this.isGeneral =
      this.solucion.params.tipoBecaExtranjero === 'CREACION_FUTURO' ||
      this.solucion.params.tipoBecaExtranjero === 'CIENCIAS_HUMANIDADES' ||
      this.solucion.params.tipoBecaExtranjero === 'ESPECIALIDADES_MEDICAS';
    const estadoSolicitud = this.solicitud?.estado;
    if (
      estadoSolicitud != null &&
      [EstadoSolicitud.ENVIADA, EstadoSolicitud.PREASIGNADA, EstadoSolicitud.EN_ASIGNACION, EstadoSolicitud.EN_CORRECCION].includes(
        estadoSolicitud
      )
    ) {
      this.solicitud.datos_conciliados.periodo.fechaInicioBeca = this.setPeriodoBeca(
        this.solicitud.datos_conciliados.periodo.fechaInicioEstudios,
        true
      );
      this.solicitud.datos_conciliados.periodo.fechaFinBeca = this.setPeriodoBeca(
        this.solicitud.datos_conciliados.periodo.fechaFinEstudios,
        false
      );
      this.solicitud.datos_conciliados.periodo.duracionBeca = this.calculaMesesSolicitados(
        this.solicitud.datos_conciliados.periodo.fechaInicioBeca,
        this.solicitud.datos_conciliados.periodo.fechaFinBeca
      );

      this.solicitud.SOLICITUD_RIZOMA.periodo.fechaInicioBeca = this.setPeriodoBeca(
        this.solicitud.SOLICITUD_RIZOMA.periodo.fechaInicioEstudios,
        true
      );
      this.solicitud.SOLICITUD_RIZOMA.periodo.fechaFinBeca = this.setPeriodoBeca(
        this.solicitud.SOLICITUD_RIZOMA.periodo.fechaFinEstudios,
        false
      );
      this.solicitud.SOLICITUD_RIZOMA.periodo.duracionBeca = this.calculaMesesSolicitados(
        this.solicitud.SOLICITUD_RIZOMA.periodo.fechaInicioBeca,
        this.solicitud.SOLICITUD_RIZOMA.periodo.fechaFinBeca
      );
    }
  }

  private fieldsRubros() {
    // Encuentra el número máximo de propiedades "anio_X" en montos
    let maxAnios = 0;
    this.solicitud.datos_conciliados.rubros.forEach((rubro: IRubro) => {
      const numAnios = Object.keys(rubro.montos).length;
      if (numAnios > maxAnios) {
        maxAnios = numAnios;
      }
      //Redondea monto al cargar informacion
      for (const key in rubro.montos) {
        if (rubro.montos.hasOwnProperty(key)) {
          // Redondear el monto sin decimales
          const montoOriginal = rubro.montos[key].monto;
          const montoRedondeado = Math.round(Number(montoOriginal));
          rubro.montos[key].monto = montoRedondeado;
        }
      }
    });

    // Agregar campos a fields basados en el número máximo de años si no existen
    for (let i = 1; i <= maxAnios; i++) {
      const key = `anio_${i}`;
      const label = `${i}º año`;

      // Verificar si el campo ya existe en fields
      const exists = this.fields.some(field => field.key === key);

      if (!exists) {
        this.fields.push({
          label: label,
          key: key,
        });
      }
    }

    // Eliminar campos que ya no son necesarios
    this.fields = this.fields.filter(field => {
      if (field.key && field.key.startsWith('anio_')) {
        const anioNumero = parseInt(field.key.split('_')[1], 10);
        return anioNumero <= maxAnios;
      }
      return true; // Mantener los campos que no empiezan con 'anio_'
    });
  }

  get isOperador(): boolean {
    return this.solucion.autoridades.some(
      user => user.usuarioId == this.userInfo.login && user.roles.some(rol => rol === RolAutoridad.OPERADOR)
    );
  }

  get isJefeDepartamento(): boolean {
    return this.solucion.autoridades.some(
      user => user.usuarioId == this.userInfo.login && user.roles.some(rol => rol === RolAutoridad.JEFE_DEPARTAMENTO)
    );
  }

  get acceso(): { acciones: any[] } {
    return this.grantService().accesos(this.solucion, this.solicitud);
  }

  get readOnly(): boolean {
    if (this.acceso.acciones.findIndex(accion => accion === TipoAccion.ESCRIBIR) === -1) {
      return true;
    }
    if (
      this.isOperador &&
      this.solicitud?.estado !== EstadoSolicitud.ENVIADA &&
      this.solicitud?.estado !== EstadoSolicitud.EN_EVALUACION &&
      this.solicitud?.estado !== EstadoSolicitud.PREASIGNADA &&
      this.solicitud?.estado !== EstadoSolicitud.EVALUADA &&
      this.solicitud?.estado !== EstadoSolicitud.EN_ASIGNACION
    ) {
      return true;
    }
    return !this.isOperador && this.solicitud?.estado !== EstadoSolicitud.ASIGNADA;
  }

  get isVisible(): boolean {
    if (
      !this.isOperador &&
      [
        EstadoSolicitud.ENVIADA,
        EstadoSolicitud.EN_EVALUACION,
        EstadoSolicitud.REVISADA,
        EstadoSolicitud.EVALUADA,
        EstadoSolicitud.EN_ASIGNACION,
        EstadoSolicitud.EN_CORRECCION,
        EstadoSolicitud.PREASIGNADA,
      ].includes(this.solicitud?.estado)
    ) {
      return false;
    }
    return true;
  }

  public limpiaComponente() {
    this.dependientesNuevo = {
      curp: null,
      nombre: null,
      primerApellido: null,
      segundoApellido: null,
      fechaNacimiento: null,
      sexo: null,
      parentesco: null,
      esExtranjero: false,
    };
    const resetId = setTimeout(() => {
      if (this.$v.dependientesNuevo.$invalid) {
        this.$v.dependientesNuevo.$reset();
      }
      {
        clearTimeout(resetId);
      }
    }, 1);
  }

  public addDependiente() {
    if (!this.$v.dependientesNuevo.$invalid) {
      const form = JSON.parse(JSON.stringify(this.dependientesNuevo));
      if (this.removeIndex === null) {
        if (this.solicitud.datos_conciliados.dependientesEconomicos.length <= 2) {
          this.solicitud.datos_conciliados.dependientesEconomicos.push(form);
          this.updtaeDependientes();
        } else {
          this.alertService().showWarning(
            this,
            this.$t('apeironGwApp.conciliacionExtranjeras.dependientes-economicos.alerts.maximo-dependientes').toString()
          );
        }
      } else {
        this.$set(this.solicitud.datos_conciliados.dependientesEconomicos, this.removeIndex, form);
        this.removeIndex = null;
        this.updtaeDependientes();
      }
      this.limpiaComponente();
      this.dependientesNuevo.esExtranjero = false;
    } else {
      this.$v.dependientesNuevo.$touch();
    }
  }

  public editDependiente(item: IDependienteEconomico, i: number) {
    this.nacionalidadDisabled = true;
    this.removeIndex = i;
    this.dependientesNuevo = JSON.parse(JSON.stringify(item));
    this.changeNacionalidad(item.esExtranjero);
  }

  public cancelModal() {
    this.removeDependiente.hide();
    this.removeIndex = null;
  }

  public removeModal(i: number) {
    this.removeDependiente.show();
    this.removeIndex = i;
  }

  public dependienteModificaModal() {
    this.changeDependiente.show();
  }

  public deleteDependiente() {
    this.solicitud.datos_conciliados.dependientesEconomicos.splice(this.removeIndex, 1);
    this.updtaeDependientes();
  }

  public cancelaDependiente() {
    this.removeIndex = null;
    this.nacionalidadDisabled = false;
    this.limpiaComponente();
  }

  public changeNacionalidad(e: boolean) {
    this.curpReadOnly = e;
    this.dependientesNuevo.esExtranjero = e;
    if (e) this.dependientesNuevo.curp = null;
  }

  public capitalsOnly() {
    this.dependientesNuevo.curp = this.dependientesNuevo.curp.toUpperCase();
  }

  /**
   * Setea y deshabilita el campo sexo dependiendo el id del catalogo parentesco
   * Habilita campo sexo cuando la opcion es conyuge, concubino y los demás.
   * @param e valor del catalogo parentesco
   */
  public sexoParentescoChange(e: ICatalogoDto) {
    if (e.id == '1' || e.id == '5' || e.id == '8') {
      this.dependientesNuevo.sexo = { id: 'F', nombre: 'Femenino' };
      this.sexoDisabled = true;
    } else if (e.id == '2' || e.id == '6' || e.id == '7') {
      this.dependientesNuevo.sexo = { id: 'M', nombre: 'Masculino' };
      this.sexoDisabled = true;
    } else {
      this.dependientesNuevo.sexo = null;
      this.sexoDisabled = false;
    }
  }

  public numbersOnly(evt: any): boolean {
    const charCode = evt.which ? evt.which : evt.keyCode;
    // Bloquea el ingreso del número 0 como único dígito y cualquier carácter que no sea un número ni el punto decimal
    if (charCode === CharCodes.CERO && evt.target.value.length === 0) {
      evt.preventDefault();
      return false;
    } else if ((charCode < CharCodes.CERO || charCode > CharCodes.NUEVE) && charCode !== CharCodes.DELETE) {
      evt.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  public initCatalogos() {
    this.nacionalidadOptions = this.solucion.params.nacionalidadOptions;
    this.parentescoOption = this.solucion.params.parentescoOption;
    this.sexoOptions = this.solucion.params.sexoOptions;

    this.catTipoApoyo();
    this.getPaises().then((listaPaisTotal: ICatalogoPaises[]) => {
      this.catPais = listaPaisTotal;
      if (this.solicitud?.datos_conciliados?.apoyo?.pais?.clave) {
        this.solicitud.datos_conciliados.apoyo.pais = this.filtraCatalogoId(this.catPais, this.solicitud.datos_conciliados.apoyo.pais.id);
        if (this.solicitud?.datos_conciliados?.apoyo?.pais?.clave === this.solucion?.params?.cuba?.clave) {
          this.solicitud.datos_conciliados.apoyo.pais.rubros = this.solucion.params.cuba.rubros;
          this.solicitud.datos_conciliados.apoyo.pais.divisa = this.solucion.params.cuba.divisa;
          this.solicitud.datos_conciliados.apoyo.pais.nombreDivisa = this.solucion.params.cuba.nombreDivisa;
          this.solicitud.datos_conciliados.apoyo.pais.region = this.solucion.params.cuba.region;
        }
      }
    });

    if (this.solucion.params.tipoBecaExtranjero == 'ESTANCIA_TECNICA_JAPON') this.getCatProgramas();

    this.InstitucionesPorPais(this.solicitud.datos_conciliados.apoyo.pais);
    this.catConveniosColab();
  }

  public confirmaDatos() {
    // Validar únicamente MANUTENCION.
    if (!this.validarMontosRubros()) {
      return;
    }

    this.solicitud.terminos_aceptados = this.confirmo;
    if (!this.$v.solicitud.$invalid && !this.inicioMaximoBecaBandera && !this.fechaInicioMayorAFinBandera) {
      this.save(this.solicitud);
    } else {
      this.$v.solicitud.$touch();
    }
  }

  public updateAjustesSolicitados() {
    this.solicitud.ajustes_solicitados = true;
    this.solicitud.terminos_aceptados = false;
    this.confirmo = !this.solicitud.ajustes_solicitados;
    this.solicitudService()
      .update(this.solicitud)
      .then(() => {
        this.alertService().showSuccess(
          this,
          this.$t('apeironGwApp.conciliacionExtranjeras.dependientes-economicos.alerts.comentario', 'Exitoso').toString()
        );
        this.onDisabledConfirma();
      })
      .catch(error => {
        this.alertService().showHttpError(this, error.response);
      });
  }

  public updtaeDependientes() {
    this.solicitud.dependientes_modificados = true;
    this.solicitud.terminos_aceptados = false;
    this.confirmo = !this.solicitud.dependientes_modificados;
    this.solicitudService()
      .update(this.solicitud)
      .then(() => {
        this.alertService().showSuccess(
          this,
          this.$t('apeironGwApp.conciliacionExtranjeras.dependientes-economicos.alerts.actualizar', 'Exitoso').toString()
        );
        this.onDisabledConfirma();
        this.dependienteModificaModal();
      })
      .catch(error => {
        this.alertService().showHttpError(this, error.response);
      });
  }

  public validateInput(item: IMontoRubro, key: string) {
    // -------------------------
    // 1. Limpiar el input
    // -------------------------
    this.valueValidateInput = item[key];
    this.valueValidateInput = this.valueValidateInput.replace(/[^0-9.]/g, '');

    if (this.valueValidateInput.split('.').length > 2) {
      this.valueValidateInput = this.valueValidateInput.replace(/\.+$/, '');
    }

    item[key] = this.valueValidateInput;
    console.log(item[key]);
    const montoIngresado = Number(item[key]);
    if (isNaN(montoIngresado)) return;

    // -------------------------
    // 2. Ubicar el rubro del input
    // -------------------------
    const rubro =
      this.solucion.params.tipoBecaExtranjero !== 'ESTANCIA_TECNICA_JAPON'
        ? this.solicitud.datos_conciliados.rubros.find(r => r.montos && Object.values(r.montos).includes(item))
        : this.solicitud.datos_conciliados.rubros.find(r => r.concepto === 'CURSO_IDIOMA_JAPONES');

    if (!rubro) return;

    // -------------------------
    // 3. Determinar qué año se está editando
    // -------------------------
    const keyAnio =
      this.solucion.params.tipoBecaExtranjero !== 'ESTANCIA_TECNICA_JAPON'
        ? Object.keys(rubro.montos).find(k => rubro.montos[k] === item)
        : '0';
    if (!keyAnio) return;

    const indexAnio = Number(keyAnio.split('_')[1]);

    // -------------------------
    // 4. Preparar datos base
    // -------------------------
    let montoMensualPermitido = 0;
    let montoanualIsste = 0;
    const conciliados = this.solicitud.datos_conciliados;
    const duracion = conciliados.periodo.duracionBeca;
    const totalPeriodos = Math.ceil(duracion / 12);

    if (
      this.solucion.params.tipoBecaExtranjero !== 'ESTANCIA_TECNICA_JAPON' &&
      this.solucion.params.tipoBecaExtranjero !== 'CONVENIO_ISSSTE'
    ) {
      if (this.solucion?.params?.rubros) {
        conciliados.apoyo.pais.rubros = this.solucion.params.rubros.find(rb => rb.divisa === rubro.moneda);
      }

      if (rubro.concepto === 'MANUTENCION') {
        const tieneDep = conciliados.dependientesEconomicos.length > 0;
        const catalogo = conciliados.apoyo.pais.rubros.manutencion;

        // monto mensual permitido
        montoMensualPermitido =
          conciliados?.apoyo?.tipoBeca?.tipo === 'CUATRO'
            ? tieneDep
              ? this.solucion.params.DAAD.MANUTENCION.DEPENIENTES
              : this.solucion.params.DAAD.MANUTENCION.SIN_DEPENIENTES
            : tieneDep
            ? catalogo.CON_DEPENDIENTES
            : catalogo.SIN_DEPENDIENTES;
      }

      //COLEGIATURA

      if (rubro.concepto === 'COLEGIATURA') {
        const apoyo = conciliados.apoyo.tipoApoyo.id;
        const catalogo = conciliados.apoyo.pais.rubros.colegiatura;

        if (apoyo === '7') montoMensualPermitido = conciliados?.apoyo?.tipoBeca?.tipo === 'CUATRO' ? 9000 : catalogo.MAESTRIA_MAX;
        if (apoyo === '8') montoMensualPermitido = conciliados?.apoyo?.tipoBeca?.tipo === 'CUATRO' ? 9000 : catalogo.DOCTORADO_MAX;
        if (apoyo === '10') montoMensualPermitido = conciliados?.apoyo?.tipoBeca?.tipo === 'CUATRO' ? 9000 : catalogo.DOCTORADO_MAX;
        if (apoyo === '9')
          montoMensualPermitido = conciliados?.apoyo?.tipoBeca?.tipo === 'CUATRO' ? 9000 : catalogo.ESPECIALIDAD_MEDICA_MAX;
      }

      //Seguro

      if (rubro.concepto === 'SEGURO_MEDICO') {
        const dependientes = conciliados.dependientesEconomicos.length;
        const tablaSeguro = conciliados.apoyo.pais?.rubros?.seguroMedico ?? conciliados.apoyo.pais.rubros?.seguro_medico;

        if (dependientes === 0) montoMensualPermitido = tablaSeguro.SIN_DEPENDIENTES;
        if (dependientes === 1) montoMensualPermitido = tablaSeguro.DEPENDIENTES_1;
        if (dependientes === 2) montoMensualPermitido = tablaSeguro.DEPENDIENTES_2;
        if (dependientes === 3) montoMensualPermitido = tablaSeguro.DEPENDIENTES_3;
      }
    } else {
      if (rubro.concepto === 'MANUTENCION') {
        montoMensualPermitido = 22660;
      }
      if (rubro.concepto === 'BOLETO_AVION' && this.solicitud.datos_conciliados.apoyo.tipoApoyo.id !== '11') {
        montoMensualPermitido = 35000;
      }

      if (
        (rubro.concepto === 'BOLETO_AVION' || rubro.concepto === 'COLEGIATURA') &&
        this.solicitud.datos_conciliados.apoyo.tipoApoyo.id === '11'
      ) {
        montoMensualPermitido = 120000;
        montoanualIsste = Number(
          this.solicitud.datos_conciliados.rubros.find(r => r.concepto !== 'MANUTENCION' && r.concepto !== rubro.concepto).montos.anio_1
            .monto
        );
      }

      if (rubro.concepto === 'CURSO_IDIOMA_JAPONES') {
        montoMensualPermitido = Number(this.solucion?.params?.rubros.find(r => r.concepto === 'CURSO_IDIOMA_JAPONES').montoTotal);
      }
    }

    // -------------------------
    // 5. Calcular meses aplicables al año (INCLUYE MESES RESTANTES)
    // -------------------------
    let mesesAplicables = 12;

    // último periodo con meses restantes
    if (indexAnio === totalPeriodos && duracion % 12 !== 0) {
      mesesAplicables = duracion % 12;
    }

    // -------------------------
    // 6. Calcular el límite anual permitido
    // -------------------------
    let maxPermitido = 0;
    if (rubro.concepto === 'MANUTENCION' && this.solicitud.datos_conciliados.apoyo.tipoApoyo.id !== '11') {
      maxPermitido = montoMensualPermitido * mesesAplicables;
    } else {
      maxPermitido = montoMensualPermitido;
    }
    if (
      (rubro.concepto === 'BOLETO_AVION' || rubro.concepto === 'COLEGIATURA') &&
      this.solicitud.datos_conciliados.apoyo.tipoApoyo.id === '11'
    ) {
      maxPermitido = montoMensualPermitido;
    }

    if (rubro.concepto === 'COLEGIATURA' && this.solicitud.datos_conciliados.apoyo.tipoApoyo.id === '12') {
      maxPermitido = montoMensualPermitido;
    }

    if (rubro.concepto === 'COLEGIATURA' && this.solucion.params.tipoBecaExtranjero !== 'CONVENIO_ISSSTE') {
      maxPermitido = montoMensualPermitido;
    }

    if (rubro.concepto === 'SEGURO_MEDICO') {
      if (mesesAplicables === 12) {
        maxPermitido = montoMensualPermitido;
      } else {
        maxPermitido = (montoMensualPermitido / 12) * mesesAplicables;
      }
    }

    if (rubro.concepto === 'CURSO_IDIOMA_JAPONES') {
      maxPermitido = montoMensualPermitido;
    }

    // -------------------------
    // 7. Validar y corregir si excede
    // -------------------------
    if (montoIngresado + montoanualIsste > maxPermitido && !this.solicitud?.isColaboracion) {
      item[key] = rubro.concepto === 'BOLETO_AVION' || rubro.concepto === 'COLEGIATURA' ? rubro.montoTotal : maxPermitido;

      this.$bvToast.toast(`El monto excede lo permitido para este periodo.`, { variant: 'warning', solid: true });
    }
  }

  public formatInput(item: IMontoRubro, key: string) {
    this.valueFormatInput = item[key];

    // Verificar si el valor es un número y no está vacío
    if (typeof this.valueFormatInput === 'number' || (typeof this.valueFormatInput === 'string' && !isNaN(Number(this.valueFormatInput)))) {
      this.valueFormatInput = String(this.valueFormatInput); // Convertir a cadena si es número

      // Verificar si la cadena contiene un punto decimal
      if (this.valueFormatInput.includes('.')) {
        this.parts = this.valueFormatInput.split('.');
        this.integerPart = this.parts[0];
        this.decimalPart = this.parts[1] ? this.parts[1].substring(0, 2) : '';
        item[key] = this.decimalPart ? `${this.integerPart}.${this.decimalPart}` : this.integerPart;
      } else {
        // Si no contiene un punto decimal, no hacer nada
        this.integerPart = this.valueFormatInput;
        this.decimalPart = '';
        item[key] = this.integerPart;
      }
    }
  }

  public onDisabledConfirma() {
    if (this.solicitud.terminos_aceptados) {
      this.confirmo = this.solicitud.terminos_aceptados;
    }
    if (this.solicitud.dependientes_modificados || this.solicitud.ajustes_solicitados) {
      this.disabledConfirmo = true;
    } else {
      this.disabledConfirmo = false;
    }
  }

  public onFechaSeleccionada(value: string) {
    const fechaSeleccionada = new Date(value);
    fechaSeleccionada.setHours(0, 0, 0, 0);
    this.$v.dependientesNuevo.fechaNacimiento.$model = fechaSeleccionada;
  }

  /**
   * Filtra un catalogo por ID
   * @param cat catalogo a filtrar
   * @param val valor por id que se va a filtrar
   * @returns catalogo filtrado
   */
  public filtraCatalogoId(cat: any[], val: string): ICatalogoBV {
    const filtro = cat.filter(e => e.value.id == val);
    return filtro.length > 0 ? filtro[0].value : null;
  }

  public catTipoApoyo() {
    if (this.solucion?.params?.tipoApoyo) {
      this.catApoyoObtener = [];
      this.solucion.params.tipoApoyo.forEach((element: ICatalogoApoyoObtener) => {
        this.catApoyoObtener.push({
          value: { id: element.id, nombre: element.nombre, duracionMeses: element.duracionMeses },
          text: element.nombre,
        });
      });
      this.solicitud.datos_conciliados.apoyo.tipoApoyo = this.filtraCatalogoId(
        this.catApoyoObtener,
        this.solicitud.datos_conciliados.apoyo.tipoApoyo.id
      );
      this.duracionMeses = this.solicitud.datos_conciliados.apoyo.tipoApoyo.duracionMeses;
    }
  }

  public async catConveniosColab() {
    this.conveniosColaboracionService()
      .obtener()
      .then(res => {
        this.catConvenios = res.data;
      })
      .catch(error => {
        this.alertService().showHttpError(this, error.response);
        throw error;
      });
  }

  /**
   * Regresa una llamada al cliente de catalogos por eso deja la promesa de un array de any
   */
  public async getPaises(pagina = 1, catCompleto = []): Promise<any[]> {
    try {
      const res = await this.catalogosApi().getAllPaises(pagina, 100);

      if (res['headers']['x-total-pages'] && this.totalPagPaises == 0) {
        this.totalPagPaises = Number(res['headers']['x-total-pages']);
      }

      if (pagina === 1) {
        catCompleto = res['data'];
      } else {
        catCompleto = catCompleto.concat(res['data']);
      }

      if (pagina >= this.totalPagPaises) {
        this.totalPagPaises = 0;
        return this.toCatalogoVue(Object.assign(catCompleto));
      }

      pagina++;
      return this.getPaises(pagina, catCompleto); // Llamada recursiva usando await para garantizar que se espera el resultado
    } catch (err) {
      if (err?.response?.data?.detail) {
        this.alertService().showError(this, err.response.data.detail);
      } else {
        this.alertService().showError(this, this.$t('error.internalServerError').toString());
      }
      return [];
    }
  }

  public toCatalogoVue(jsonData: Array<any>): Array<any> {
    const catalogo = [];
    jsonData.forEach(element => {
      catalogo.push({ value: element, text: element.nombre });
    });
    return catalogo;
  }

  /**
   * Regresa una llamada al cliente de catalogos por esose deja la promesa de un array de any
   */
  public async getInstitucionesCompletas(clavePais: string, pagina = 1, catCompleto = []): Promise<any[]> {
    try {
      const res = await this.catalogosApi().getInstitucionesByPais(clavePais, pagina, 100);

      if (res['headers']['x-total-pages'] && this.totalPagInstituciones == 0) {
        this.totalPagInstituciones = Number(res['headers']['x-total-pages']);
      }

      if (pagina === 1) {
        catCompleto = res['data'];
      } else {
        catCompleto = catCompleto.concat(res['data']);
      }

      if (pagina >= this.totalPagInstituciones) {
        this.totalPagInstituciones = 0;
        return this.toCatalogoVue(Object.assign(catCompleto));
      }

      pagina++;
      return await this.getInstitucionesCompletas(clavePais, pagina, catCompleto);
    } catch (err) {
      if (err?.response?.data?.detail) {
        this.alertService().showError(this, err.response.data.detail);
      } else {
        this.alertService().showError(this, this.$t('error.internalServerError').toString());
      }
      return [];
    }
  }

  public InstitucionesPorPais(p: ICatalogoGenericoDto) {
    this.getInstitucionesCompletas(p.clave).then((listaInstTotal: IInstitucionesMs[]) => {
      this.catInstituciones = listaInstTotal;
      if (this.catInstituciones.length > 0) {
        this.solicitud.datos_conciliados.apoyo.institucion = this.filtraCatalogoId(
          this.catInstituciones,
          this.solicitud.datos_conciliados.apoyo.institucion.id
        );
      } else {
        this.solicitud.datos_conciliados.apoyo.institucion = null;
      }
    });
  }

  public changeConvenio(e: IInstitucionesMs) {
    this.solicitud.datos_conciliados.apoyo.convenio = e.convenio;
  }

  convenioOnly(): boolean {
    if (this.solicitud.isColaboracion) {
      this.showConvenios = true;
      return this.showConvenios;
    } else {
      this.showConvenios = false;
      return this.showConvenios;
    }
  }

  get opcionesConvenios() {
    return this.catConvenios
      .slice()
      .sort((a, b) => a.descripcion.localeCompare(b.descripcion, 'es', { sensitivity: 'base' }))
      .map(c => ({
        value: c.id,
        text: c.descripcion,
      }));
  }

  //Periodos
  public setInicioBeca() {
    this.solicitud.datos_conciliados.periodo.fechaInicioBeca = null;
    this.solicitud.datos_conciliados.periodo.fechaFinEstudios = null;
    this.solicitud.datos_conciliados.periodo.fechaFinBeca = null;
    this.solicitud.datos_conciliados.periodo.duracionBeca = null;
    this.inicioMaximoBecaBandera = false;
    if (this.solicitud.datos_conciliados.periodo.fechaInicioEstudios) {
      if (this.fechaMayor(this.solicitud.datos_conciliados.periodo.fechaInicioEstudios, this.inicioMaximoBeca, true)) {
        this.inicioMaximoBecaBandera = true;
        this.solicitud.datos_conciliados.periodo.fechaInicioBeca = this.formatoFecha(this.inicioMaximoBeca);
      } else {
        this.inicioMaximoBecaBandera = false;
        this.solicitud.datos_conciliados.periodo.fechaInicioBeca = this.setPeriodoBeca(
          this.solicitud.datos_conciliados.periodo.fechaInicioEstudios,
          true
        );
      }
    }
  }

  public setFinBeca() {
    if (this.solicitud.datos_conciliados.periodo.fechaFinEstudios) {
      this.fechaInicioMayorAFinBandera = this.fechaMayor(
        this.solicitud.datos_conciliados.periodo.fechaInicioEstudios,
        this.solicitud.datos_conciliados.periodo.fechaFinEstudios,
        false
      );
      this.solicitud.datos_conciliados.periodo.fechaFinBeca = this.setPeriodoBeca(
        this.solicitud.datos_conciliados.periodo.fechaFinEstudios,
        false
      );
      this.solicitud.datos_conciliados.periodo.duracionBeca = this.calculaMesesSolicitados(
        this.solicitud.datos_conciliados.periodo.fechaInicioBeca,
        this.solicitud.datos_conciliados.periodo.fechaFinBeca
      );
      if (this.solucion.params.tipoBecaExtranjero != 'ESTANCIA_TECNICA_JAPON') this.rubrosPeriodo();
    } else {
      this.solicitud.datos_conciliados.periodo.fechaFinBeca = null;
      this.solicitud.datos_conciliados.periodo.duracionBeca = null;
    }
  }

  /**
   *** Inicio de la Beca
   * Si el programa de estudios inicia entre el 1 y el 15 del mes, se establece el inicio de la beca el 1ro del mes.
   * Si el programa inicia entre el 16 y el 30/31 del mes, se establece el inicio de la beca el 1ro del mes siguiente.
   *** Término de la Beca
   * Si el programa finaliza entre el 1 y el 15 del mes, se establece el fin de beca el 30/31 del mes anterior.
   * Si el programa finaliza entre el 16 y el 30/31 del mes, se establece el fin de beca el 30/31 del mismo mes.
   * fecha => se obtiene la fecha desde el calendario
   * inicio => de donde viene si del calendario de INICIO o calendario de FIN
   */
  public setPeriodoBeca(fecha: string, inicio: boolean): string {
    // Parsear la fecha con Day.js y convertirla a la zona horaria deseada
    const date = dayjs(fecha).tz(AMERICA_MEXICO);

    const anio = date.format(DATE_ONLY_YEAR);
    const mes = date.format(DATE_ONLY_MONTH);
    const dia = date.format(DATE_ONLY_DAY);

    const [diaI, mesI, anioI] = this.inicioMinimoBeca.split('-');
    //si viene la fecha de inicio
    if (inicio) {
      //Si el año seleccionado es igual o mayor al año de inicioMinimoBeca entra validación de mayor o igual al día 16
      if (anio >= anioI) {
        this.fechaPeriodo =
          mes < mesI && anio == anioI
            ? `${diaI}/${mesI}/${anioI}`
            : new Date(Number(anio), Number(mes) - 1, 1).toLocaleDateString(ES_MX, this.optionsLocalDateMx);
      } else {
        //Si es menor setea la fecha de inicioMinimoBeca
        this.fechaPeriodo = `${diaI}/${mesI}/${anioI}`;
      }
    } else {
      //Si es fecha Fin
      //obtenemos fecha inicio para obtener meses
      const fechaInicio = new Date(`${this.solicitud.datos_conciliados.periodo.fechaInicioBeca}T00:00:00`);
      //obtenemos fecha fin desde el parametro de entrada para obtener meses
      const fechaFin = new Date(`${fecha}T00:00:00`);
      //Calcula la diferencia en años multiplicando la diferencia entre los años de las dos fechas por 12
      //Retorna el resultado que es el número total de meses entre las dos fechas
      const diffMeses = (fechaFin.getFullYear() - fechaInicio.getFullYear()) * 12 + (fechaFin.getMonth() - fechaInicio.getMonth());
      //Si la diffMeses es menor setea fecha seleccionada
      if (this.duracionMeses !== '') {
        if (diffMeses < Number(this.duracionMeses)) {
          this.fechaPeriodo = new Date(Number(anio), Number(mes), 0).toLocaleDateString(ES_MX, this.optionsLocalDateMx);
        } else {
          //Si la diffMeses es mayor setea fecha final sumando los meses de duracionMeses dependiendo del Tipo de apoyo
          this.fechaPeriodo = new Date(
            fechaInicio.getFullYear(),
            fechaInicio.getMonth() + Number(this.duracionMeses),
            0
          ).toLocaleDateString(ES_MX, this.optionsLocalDateMx);
        }
      }
    }
    const [d, m, a] = this.fechaPeriodo.split('/');
    const m2 = m.padStart(2, '0');
    const d2 = d.padStart(2, '0');
    return `${a}-${m2}-${d2}`;
  }

  //Retorna el resultado que es el número total de meses entre las dos fechas +1
  public calculaMesesSolicitados(inicioBeca: string, finBeca: string): number {
    const inicio = new Date(`${inicioBeca}T00:00:00`);
    const fin = new Date(`${finBeca}T00:00:00`);
    const result = (fin.getFullYear() - inicio.getFullYear()) * 12 + (fin.getMonth() - inicio.getMonth()) + 1;
    return result < 0 ? 0 : result;
  }

  public fechaMayor(fecha1: string, fecha2: string, inicio: boolean): boolean {
    const fecha1Date = new Date(`${fecha1}T00:00:00`);
    const [dia, mes, anio] = fecha2.split('-');
    const fecha2Date = inicio ? new Date(`${anio}-${mes}-${dia}T00:00:00`) : new Date(`${fecha2}T00:00:00`);
    return fecha1Date.getTime() > fecha2Date.getTime();
  }

  public obtenerMesAnio(fecha: string, tipo: string): number {
    if (fecha) {
      const [d, m, a] = fecha.split('-');
      const date = new Date(`${a}-${m}-${d}T00:00:00`);
      return tipo == 'MM' ? date.getMonth() : date.getFullYear();
    }
    return this.today.getMonth();
  }

  public formatoFecha(fechaString: string): string {
    const partes = fechaString.split('-'); // Dividir la cadena en partes utilizando el guion como separador
    const dia = partes[0];
    const mes = partes[1];
    const anio = partes[2];
    return `${anio}-${mes}-${dia}`;
  }

  /**
   * Actualiza los rubros permitidos según el tipo de beca seleccionado (Solo para CIENCIAS_HUMANIDADES)
   */
  @Watch('solicitud.datos_conciliados.apoyo.tipoBeca')
  public watchTipoBeca(newTipoBeca: any) {
    if (
      this.solucion.params.tipoBecaExtranjero === TipoBecaExtranjero.CIENCIAS_HUMANIDADES &&
      newTipoBeca &&
      this.solucion.params.tipoBeca &&
      this.solicitud.datos_conciliados.rubros
    ) {
      const tipoBecaInfo = this.solucion.params.tipoBeca.find(t => t.tipo === newTipoBeca.tipo);
      if (tipoBecaInfo) {
        const rubrosRequeridos = tipoBecaInfo.rubros;

        // 1. Eliminar rubros que no correspondan al nuevo tipo
        this.solicitud.datos_conciliados.rubros = this.solicitud.datos_conciliados.rubros.filter(r =>
          rubrosRequeridos.includes(r.concepto)
        );

        // 2. Agregar rubros faltantes
        rubrosRequeridos.forEach(concepto => {
          const existe = this.solicitud.datos_conciliados.rubros.find(r => r.concepto === concepto);
          const rubroOriginal = this.solicitud.SOLICITUD_RIZOMA?.rubros?.find(r => r.concepto === concepto);
          const colegiatura = this.solicitud.SOLICITUD_RIZOMA.rubros.find(r => r.concepto === concepto && r.concepto === 'COLEGIATURA');
          if (!existe) {
            let moneda = 'USD';
            if (this.solicitud.datos_conciliados.rubros.length > 0) {
              moneda = this.solicitud.datos_conciliados.rubros[0].moneda;
            } else if (this.solicitud.datos_conciliados.apoyo.pais && this.solicitud.datos_conciliados.apoyo.pais.divisa) {
              moneda = this.solicitud.datos_conciliados.apoyo.pais.divisa;
            }

            this.solicitud.datos_conciliados.rubros.push({
              concepto: concepto,
              moneda: moneda,
              montoTotal: colegiatura?.montoTotal ?? 0,
              periodo: concepto === 'SEGURO_MEDICO' ? 'ANUAL' : rubroOriginal?.periodo,
              montos: {},
            });
          }
        });

        // 3. Recalcular montos y periodos
        this.rubrosPeriodo();
      }
    }
  }

  /**
   * Recalcula los rubros a partir del cambio del periodo de beca
   */
  @Watch('solicitud.datos_conciliados.periodo.fechaInicioBeca')
  public rubrosPeriodo() {
    // Calcular cuántos periodos adicionales de 12 meses hay
    const duracionBeca = this.solicitud.datos_conciliados.periodo.duracionBeca;
    const totalPeriodos = Math.ceil(duracionBeca / 12);

    this.solicitud.datos_conciliados.rubros.forEach((rubro: IRubro) => {
      // Verificar y inicializar 'montos' si no existe
      if (!rubro.montos) {
        rubro.montos = {};
      }

      // Agregar o actualizar montos
      for (let i = 1; i <= totalPeriodos; i++) {
        const nuevoAnio = `anio_${i}`;
        const fechaInicioBeca = new Date(`${this.solicitud.datos_conciliados.periodo.fechaInicioBeca}T00:00:00`);
        const sumaAnio = fechaInicioBeca.getFullYear() - 1;
        const anio = sumaAnio + i;
        let montoTotal = 0;

        if (
          this.solucion.params.tipoBecaExtranjero !== 'ESTANCIA_TECNICA_JAPON' &&
          this.solucion.params.tipoBecaExtranjero !== 'CONVENIO_ISSSTE'
        ) {
          if (this.solucion?.params?.rubros && this.solucion.params.tipoBecaExtranjero === TipoBecaExtranjero.CIENCIAS_HUMANIDADES) {
            this.solicitud.datos_conciliados.apoyo.pais.rubros = this.solucion.params.rubros.find(rb => rb.divisa === rubro.moneda);
          }
          if (rubro.concepto === 'MANUTENCION' && this.solicitud.datos_conciliados.dependientesEconomicos.length === 0) {
            if (this.solicitud.datos_conciliados.apoyo?.tipoBeca?.tipo === 'CUATRO') {
              montoTotal = this.solucion?.params?.DAAD?.MANUTENCION?.SIN_DEPENIENTES;
              console.log(montoTotal);
            } else {
              montoTotal = this.solicitud.datos_conciliados.apoyo.pais.rubros.manutencion.SIN_DEPENDIENTES;
            }
          } else if (rubro.concepto === 'MANUTENCION' && this.solicitud.datos_conciliados.dependientesEconomicos.length !== 0) {
            if (this.solicitud.datos_conciliados.apoyo?.tipoBeca?.tipo === 'CUATRO') {
              montoTotal = this.solucion?.params?.DAAD?.MANUTENCION?.DEPENIENTES;
            } else {
              montoTotal = this.solicitud.datos_conciliados.apoyo.pais.rubros.manutencion.CON_DEPENDIENTES;
            }
          }
          const seguro =
            this.solicitud.datos_conciliados.apoyo.pais?.rubros?.seguroMedico ??
            this.solicitud.datos_conciliados.apoyo.pais?.rubros?.seguro_medico;
          if (rubro.concepto === 'SEGURO_MEDICO' && this.solicitud?.datos_conciliados?.dependientesEconomicos.length === 1) {
            montoTotal = seguro.DEPENDIENTES_1;
          } else if (rubro.concepto === 'SEGURO_MEDICO' && this.solicitud?.datos_conciliados?.dependientesEconomicos.length === 2) {
            montoTotal = seguro.DEPENDIENTES_2;
          } else if (rubro.concepto === 'SEGURO_MEDICO' && this.solicitud?.datos_conciliados?.dependientesEconomicos.length === 3) {
            montoTotal = seguro.DEPENDIENTES_3;
          } else if (rubro.concepto === 'SEGURO_MEDICO' && this.solicitud?.datos_conciliados?.dependientesEconomicos.length === 0) {
            montoTotal = seguro.SIN_DEPENDIENTES;
          }

          if (rubro.concepto === 'COLEGIATURA') {
            montoTotal = rubro.montoTotal;
          }
        } else {
          montoTotal = rubro.montoTotal;
        }

        // Calcular el monto anual por defecto
        let montoAnual = montoTotal * 12;

        // Lógica específica para 'MANUTENCION'
        if (
          rubro.concepto === 'MANUTENCION' &&
          this.solucion.params.tipoBecaExtranjero === 'CONVENIO_ISSSTE' &&
          this.solicitud.datos_conciliados.apoyo.tipoApoyo.id === '11'
        ) {
          montoAnual = montoTotal;
        } else if (rubro.concepto === 'MANUTENCION' && i === totalPeriodos && duracionBeca % 12 !== 0) {
          const mesesRestantes = duracionBeca % 12;
          montoAnual = montoTotal * mesesRestantes;
        }

        // Lógica para 'SEGURO_MEDICO' solo si hay meses restantes en el último año
        if (rubro.concepto === 'SEGURO_MEDICO' && i === totalPeriodos) {
          const mesesRestantes = duracionBeca % 12;
          if (mesesRestantes !== 0) {
            montoAnual = (montoTotal / 12) * mesesRestantes;
          } else {
            montoAnual = montoTotal; // Usar el monto total si es un año completo
          }
        } else if (rubro.concepto === 'SEGURO_MEDICO') {
          montoAnual = montoTotal; // Mantener el monto total para años completos
        }

        // Lógica para 'COLEGIATURA'  solo si hay meses restantes en el último año
        if (rubro.concepto === 'COLEGIATURA' && i === totalPeriodos && this.solucion.params.tipoBecaExtranjero !== 'CONVENIO_ISSSTE') {
          const mesesRestantes = duracionBeca % 12;
          if (mesesRestantes !== 0) {
            montoAnual = (rubro.montoTotal / 12) * mesesRestantes;
          } else {
            montoAnual = rubro.montoTotal; // Usar el monto total si es un año completo
          }
        } else if (rubro.concepto === 'COLEGIATURA') {
          montoAnual = rubro.montoTotal; // Mantener el monto total para años completos
        }

        if (rubro.concepto === 'BOLETO_AVION') {
          montoAnual = rubro.montoTotal; // Mantener el monto total para años completos
        }

        // Agregar o actualizar el objeto con la clave dinámica
        rubro.montos[nuevoAnio] = {
          anio: anio,
          monto: Math.round(Number(montoAnual)),
        };
        rubro.montoTotal = montoTotal;
      }

      // Eliminar años sobrantes si existen
      const aniosExistentes = Object.keys(rubro.montos);
      aniosExistentes.forEach(anioKey => {
        const anioNumero = parseInt(anioKey.split('_')[1], 10);
        if (anioNumero > totalPeriodos) {
          delete rubro.montos[anioKey];
        }
      });
    });
    this.fieldsRubros();
    this.tableRubros.refresh();
  }

  /**
   * Obtiene programas de los parametos
   */
  public getCatProgramas() {
    const programas = this.solucion.params.programas;
    this.catPrograma = [];
    programas.forEach(element => {
      this.catPrograma.push({
        value: element.nombre,
        text: element.nombre,
      });
    });
  }

  /**
   * Obtiene programas de los parametos
   */
  public getNombreRubro(rubro: string): string {
    switch (rubro) {
      case 'MANUTENCION':
        if (this.issste) {
          return 'Apoyo económico';
        }
        return this.solucion?.params?.manutencion ?? 'MANUTENCION';
        break;
      case 'COLEGIATURA':
        if (this.issste) {
          return 'Apoyo complementario para formación';
        }
        return this.solucion?.params?.colegiatura ?? 'COLEGIATURA';
        break;
      case 'SEGURO_MEDICO':
        if (this.issste) {
          return 'Apoyo para gastos de seguro médico';
        }
        return this.solucion?.params?.seguroMedico ?? 'SEGURO_MEDICO';
        break;
      case 'BOLETO_AVION':
        return 'Apoyo complementario para traslado';
        break;
      default:
        return rubro;
        break;
    }
  }

  public erroresMontos: any[] = [];
  public validarMontosRubros(): boolean {
    const rubros: IRubro[] = this.solicitud?.datos_conciliados?.rubros ?? [];

    // Si no existen rubros, no hay nada que validar.
    if (rubros.length === 0) {
      return true;
    }

    const errores: any[] = [];

    const duracionBeca = Number(this.solicitud?.datos_conciliados?.periodo?.duracionBeca);

    // Si la duración no es válida, no podemos calcular los periodos.
    if (!duracionBeca || duracionBeca <= 0) {
      return true;
    }

    /*
     * Los periodos son anuales.
     *
     * Ejemplos:
     * 12 meses  -> 1 periodo
     * 24 meses  -> 2 periodos
     * 30 meses  -> 3 periodos (12 + 12 + 6)
     * 48 meses  -> 4 periodos
     * 50 meses  -> 5 periodos (12 + 12 + 12 + 12 + 2)
     */
    const totalPeriodos = Math.ceil(duracionBeca / 12);

    rubros.forEach((rubro: IRubro) => {
      // Por ahora la validación únicamente aplica a MANUTENCION.
      if (rubro.concepto !== 'MANUTENCION') {
        return;
      }

      const montoMensual = Number(rubro.montoTotal);

      // Validar que exista un monto mensual válido.
      if (isNaN(montoMensual) || montoMensual <= 0) {
        errores.push({
          concepto: rubro.concepto,
          mensaje: 'El monto mensual registrado no es válido.',
        });

        return;
      }

      // Validar que existan montos por periodo.
      if (!rubro.montos) {
        errores.push({
          concepto: rubro.concepto,
          mensaje: 'No existen montos registrados por periodo.',
        });

        return;
      }

      Object.keys(rubro.montos).forEach(key => {
        const montoPeriodo = Number(rubro.montos[key]?.monto);

        const numeroPeriodo = Number(key.replace('anio_', ''));

        // Ignorar propiedades que no correspondan a un periodo.
        if (!numeroPeriodo) {
          return;
        }

        // Validar que el monto del periodo sea numérico.
        if (isNaN(montoPeriodo)) {
          errores.push({
            concepto: rubro.concepto,
            periodo: key,
            anio: rubro.montos[key]?.anio,
            mensaje: 'El monto registrado no es válido.',
          });

          return;
        }

        /*
         * Cada periodo corresponde a un máximo de 12 meses.
         *
         * Si la duración total no es múltiplo de 12,
         * el último periodo tendrá únicamente los meses restantes.
         *
         * Ejemplo:
         * duracionBeca = 30
         *
         * anio_1 = 12 meses
         * anio_2 = 12 meses
         * anio_3 = 6 meses
         */
        let mesesPeriodo = 12;

        if (numeroPeriodo === totalPeriodos && duracionBeca % 12 !== 0) {
          mesesPeriodo = duracionBeca % 12;
        }

        /*
         * Calcular cuánto debería tener registrado
         * el periodo según el monto mensual.
         */
        const montoEsperado = montoMensual * mesesPeriodo;

        // Redondear a dos decimales para evitar problemas
        // de precisión de JavaScript con números decimales.
        const esperado = Math.round(montoEsperado * 100) / 100;

        const registrado = Math.round(montoPeriodo * 100) / 100;

        /*
         * Si el monto esperado y el registrado no coinciden,
         * guardar toda la información para mostrarla en el modal.
         */
        if (esperado !== registrado) {
          errores.push({
            concepto: rubro.concepto,
            periodo: key,
            anio: rubro.montos[key]?.anio,
            montoMensual,
            mesesPeriodo,
            montoEsperado: esperado,
            montoRegistrado: registrado,
            diferencia: Math.abs(esperado - registrado),
          });
        }
      });
    });

    /*
     * Guardamos los errores para que el modal pueda
     * mostrarlos de manera estructurada.
     */
    this.erroresMontos = errores;

    /*
     * Si existen inconsistencias, mostrar el modal
     * y evitar que el proceso continúe.
     */
    if (this.erroresMontos.length > 0) {
      this.$nextTick(() => {
        (this.$refs.montosInvalidos as any)?.show();
      });

      return false;
    }

    return true;
  }
}
